// import { MODULES_NAME } from "../constant/constant";
// import { usersAccess } from "./rolesHelper";
import ReactGA from "react-ga4";
import {
  DOCUMENT_UPLOAD_MAX_SIZE,
  SERVICE_TYPE,
  ASSET_TYPE,
  GET_ITEM_LOG,
  ORG_STATUS,
  LOGIN_ORG_ID,
  ORG_ID,
  SEFETY_HBN_CLIENT_PARTNER_PRI,
  SEFETY_HBN_CLIENT_SYSTEM_PRI,
  HBN_LIMITED_INSPECTOR_ROLE,
  OSHA_MANAGEMENT_ROLE,
  SUPERVISOR_ROLE,
  YES_NO,
} from "../constant/constant";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { useEffect, useRef } from "react";

// limit the number of charaters in input
import imageCompression from "browser-image-compression";
//import heic2any from "heic2any";
import _ from "lodash";
import moment from "moment";
import tzlookup from "tz-lookup";
import { toast } from "react-toastify";
import UserPool from "../UserPool";
import { CognitoUser, CognitoRefreshToken } from "amazon-cognito-identity-js";
import { PRODUCT_ID, IANA_TO_TIMEZONE_KEY } from "../constant/storm-water/constant";
import { hasAllPrivileges } from "./rolesHelper";

export const maxLengthCheck = (object) => {
  if (object.target.value.length > object.target.maxLength) {
    object.target.value = object.target.value.slice(0, object.target.maxLength);
  }
};

// handle the API error data
export const apiError = (errorObject) => {
  return errorObject.response ? errorObject.response : errorObject;
};

// Parse a "lat,lng" string into { lat, lng } numbers.
// Returns null when the input is missing, not a string, not exactly two
// numeric parts, or any part is non-numeric.
export const parseLatLng = (location) => {
  if (!location || typeof location !== "string") return null;
  const parts = location.split(",");
  if (parts.length !== 2) return null;
  if (parts[0].trim() === "" || parts[1].trim() === "") return null;
  const lat = Number(parts[0]);
  const lng = Number(parts[1]);
  if (Number.isNaN(lat) || Number.isNaN(lng)) return null;
  return { lat, lng };
};

// Derive a supported timezone key from a "lat,lng" location string.
// Returns { key, error } where error is "invalid" | "unsupported" | null.
export const detectTimezoneFromLocation = (location) => {
  if (!location || !location.trim()) {
    return { key: null, error: null };
  }
  const [lat, lng] = location.split(",").map(Number);
  if (Number.isNaN(lat) || Number.isNaN(lng)) {
    return { key: null, error: "invalid" };
  }
  let iana;
  try {
    iana = tzlookup(lat, lng);
  } catch (e) {
    // tz-lookup throws RangeError for out-of-earth-range coordinates
    return { key: null, error: "invalid" };
  }
  const key = IANA_TO_TIMEZONE_KEY[iana];
  if (!key) {
    return { key: null, error: "unsupported" };
  }
  return { key, error: null };
};

export const getFormatedDate = (date) => {
  if (!date) return "";
  let parsedDate;
  if (typeof date === "string" && /^\d{2}-\d{2}-\d{2,4}$/.test(date)) {
    const parts = date.split("-");
    const mm = parseInt(parts[0], 10);
    const dd = parseInt(parts[1], 10);
    let year = parts[2];
    if (year.length === 2) {
      const yr = parseInt(year, 10);
      year = yr >= 50 ? `19${yr}` : `20${yr}`;
    }
    const yyyy = parseInt(year, 10);
    parsedDate = new Date(yyyy, mm - 1, dd);
  } else {
    parsedDate = new Date(date);
  }
  if (isNaN(parsedDate)) return "";
  const dd = String(parsedDate.getDate()).padStart(2, "0");
  const mm = String(parsedDate.getMonth() + 1).padStart(2, "0");
  const yyyy = parsedDate.getFullYear();
  return `${mm}-${dd}-${yyyy}`;
};

export const getDisplayDateSlash = (value) => {
  const formatted = getFormatedDate(value);
  return formatted ? formatted.split("-").join("/") : "";
};

// Normalize a DatePicker value into a real Date for MUI's AdapterDateFns.
// The pickers require a Date instance; passing a formatted string (e.g. the
// "MM-DD-YYYY" produced by getFormatedDate) leaves the selected date unrendered.
// Months/days are built in local time to avoid the UTC off-by-one that
// `new Date("YYYY-MM-DD")` introduces in timezones behind UTC.
export const coerceDateValue = (value) => {
  if (!value) return null;
  if (value instanceof Date) return value;
  if (typeof value !== "string") return null;
  const parts = value.match(/^(\d{1,2})[-/](\d{1,2})[-/](\d{4})$/);
  if (parts) {
    const mm = parseInt(parts[1], 10);
    const dd = parseInt(parts[2], 10);
    const yyyy = parseInt(parts[3], 10);
    const d = new Date(yyyy, mm - 1, dd);
    return isNaN(d) ? null : d;
  }
  const d = new Date(value);
  return isNaN(d) ? null : d;
};

// get localTime mm-dd-yyyy hh:mm from utcDate time
export const convertUTCtoLocalTimeZone = (utcDateString, dateOnly = false) => {
  if (_.isEmpty(utcDateString)) return "";

  const date = utcDateString.endsWith("Z")
    ? utcDateString
    : utcDateString + "Z";

  const utcDate = new Date(date);

  const year = utcDate.getFullYear();
  const month = String(utcDate.getMonth() + 1).padStart(2, "0");
  const day = String(utcDate.getDate()).padStart(2, "0");

  if (dateOnly) {
    return `${month}-${day}-${year}`; // Only date
  }

  const hours = String(utcDate.getHours()).padStart(2, "0");
  const minutes = String(utcDate.getMinutes()).padStart(2, "0");

  return `${month}-${day}-${year} ${hours}:${minutes}`;
};

export const caseFormatDate = (date) => {
  var d = new Date(date),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear();
  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return [year, month, day].join("/");
};

export const getCurrentDate = (swCurrent) => {
  const today = new Date();
  const padZero = (num) => (num < 10 ? "0" + num : num);
  const yyyy = today.getFullYear();
  const mm = padZero(today.getMonth() + 1); // January is 0, so add 1
  const dd = padZero(today.getDate());
  return swCurrent ? `${mm}-${dd}-${yyyy}` : `${yyyy}-${mm}-${dd}`;
};

export const getCurrentTime = () => {
  const today = new Date();
  return today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
};

export const getCurrentMinuteSecond = () => {
  const today = new Date();
  return `${convertTwoDigit(today.getHours())}:${convertTwoDigit(
    today.getMinutes(),
  )}`;
};

export const convertTime = (time) => {
  const today = new Date();
  if (time) {
    const timeSplit = time?.split(":");
    return timeSplit[0] + ":" + timeSplit[1] + ":" + today?.getSeconds();
  } else {
    return time;
  }
};

const convertTwoDigit = (val) => {
  if (String(val).length === 1) {
    return `0${val}`;
  } else {
    return String(val);
  }
};

export const formatOrNA = (value) => {
  if (value === null || value === undefined || value === "") {
    return "N/A";
  }
  return value;
};

export const formatAccidentLocation = (vehicleAccident) => {
  const hasValue = (val) => val !== null && val !== undefined && val !== "";

  if (hasValue(vehicleAccident?.locationOfAccident)) {
    return vehicleAccident.locationOfAccident;
  }

  return [vehicleAccident?.roadway, vehicleAccident?.city, vehicleAccident?.state]
    .filter(hasValue)
    .join(", ");
};

export const getDynamicFields = (dynamicFields, fieldId) => {
  const data = dynamicFields?.find((x) => x.fieldId === fieldId)?.fieldValue;
  return data;
};

export const removeWordSpace = (value) => {
  return value.replace(/ /g, "").toLowerCase();
};

export const findObject = (list, value) => {
  if (list && value) {
    const findData = list.find((dataFind) => dataFind.key == value);
    return `${findData.key}|${findData.value}`;
  }
  return "";
};

export const getFirstValue = (value) => {
  if (value && value.includes("|")) {
    return value.split("|")[0];
  }
  return "";
};

export const getSignatureValue = (value) => {
  let isSignature = false;
  if (value && value.includes("|")) {
    const signatureText = value.split("|")[0];
    isSignature = signatureText.toLowerCase() === "true";
  }
  return isSignature;
};

export function dateValiadtor(date) {
  let dateformat =
    /^(0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])[\/\-]\d{4}$/;
  // Matching the date through regular expression
  if (date == "Invalid Date") return false;
  if (date.match(dateformat)) {
    let operator = date.split("-");
    // Extract the string into month, date and year
    let datepart = [];
    if (operator.length > 1) {
      datepart = date.split("-");
    }
    let month = parseInt(datepart[0]);
    let day = parseInt(datepart[1]);
    let year = parseInt(datepart[2]);

    // Create a list of days of a month
    let ListofDays = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    if (month === 1 || month > 2) {
      if (day > ListofDays[month - 1]) {
        //to check if the date is out of range
        return false;
      }
    } else if (month === 2) {
      let leapYear = false;
      if ((!(year % 4) && year % 100) || !(year % 400)) leapYear = true;
      if (leapYear === false && day >= 29) return false;
      else if (leapYear === true && day > 29) {
        return false;
      }
    }
  } else {
    return false;
  }
  return "Valid date";
}

export const findValueMultipleSelect = (arrrayofObject, selectedArray) => {
  let valueArray = [];
  arrrayofObject.forEach((data) => {
    if (selectedArray.indexOf(data.value) >= 0) {
      valueArray.push(data.key);
    }
  });
  return valueArray;
};

export const getDateWithDay = (days) => {
  const d = new Date();
  d.setDate(d.getDate() + days);
  return {
    getCurrentDate: getFormatedDate(new Date()),
    futureData: getFormatedDate(d),
  };
};

export const getDateWithDayPast = (days) => {
  const d = new Date();
  d.setDate(d.getDate() - days);
  return {
    getCurrentDate: getFormatedDate(new Date()),
    pastData: getFormatedDate(d),
  };
};

// //check access to get the open item logs by user/roless
// export const checkAccessForLogs = () => {
//   const userInfo = JSON.parse(localStorage.getItem("userInfo"));
//   if (userInfo?.isClient) {
//     return true;
//   }
//   const adminAccess = usersAccess(MODULES_NAME.admin);
//   const inspectionAccess = usersAccess(MODULES_NAME.inspection);
//   const incidentAccess = usersAccess(MODULES_NAME.incident);
//   if (adminAccess.isFullAppAccess || adminAccess.isLimitedInspectorAccess) {
//     return true;
//   }
//   if (inspectionAccess.isFullAccess && !incidentAccess.isFullAccess) {
//     return true;
//   }
//   return false;
// };

export const checkAlphnumeric = (dataval) => {
  const re2 = /^[a-zA-Z0-9 ]+$/;
  //let removeWhiteSpaceDta = dataval.replace(/\s+/g, " ");

  if (re2.test(dataval)) {
    return re2.test(dataval);
  }
};
export const getFileExtension = (url) => {
  const parts = url?.split(".");
  return parts[parts?.length - 1];
};
export const randomStingByLength = (length) => {
  let result = "";
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const charactersLength = characters.length;
  let counter = 0;
  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    counter += 1;
  }
  return result;
};
// Safety Open-Item column visable and hide
export const setColumnVisibilityModel1 = (newModel, localstorageName) => {
  localStorage.setItem(localstorageName, JSON.stringify(newModel));
};

export const columnVisibilityModel = {
  // safety open iTEM COLOMNS default value

  category: false,
  subCategory: false,
  questions: false,
  location: false,
  addedBy: false,
  inspectionTitle: false,
  assignedToName: false,
};
export const onlyContainsNumbers = (str) => /^\d+$/.test(str);

export const getRandomNumber = () => {
  var timestamp = new Date().toISOString().replace(/[-:.]/g, "");
  var random = ("" + Math.random()).substring(2, 8);
  var random_number = timestamp + random;
  return random_number;
};

const IMAGE_EXTENSIONS = [
  "png",
  "jpg",
  "jpeg",
  "gif",
  "svg",
  "tif",
  "heic",
  "heif",
];
const DOCUMENT_EXTENSIONS = [
  "doc",
  "docx",
  "ppt",
  "pptx",
  "xls",
  "xlsx",
  "zip",
];
const PDF_EXTENSIONS = ["pdf"];
// Browsers cannot render these image formats directly, so a placeholder is shown instead.
const UNSUPPORTED_PREVIEW_EXTENSIONS = ["tif", "heic", "heif"];
const getFileExtensionName = (url) => {
  return url?.split(".").pop()?.split("?")[0];
};
export const getFileInfo = (url) => {
  const fileNameSplit = url?.split("/");
  const fileName = fileNameSplit?.length > 0 && fileNameSplit.slice(-1).pop();
  const fileExtension = getFileExtensionName(url);
  const isImage = IMAGE_EXTENSIONS.includes(fileExtension?.toLowerCase());
  const isDocument = DOCUMENT_EXTENSIONS.includes(fileExtension?.toLowerCase());
  const isPdf = PDF_EXTENSIONS.includes(fileExtension?.toLowerCase());
  const isPreviewUnsupported = UNSUPPORTED_PREVIEW_EXTENSIONS.includes(
    fileExtension?.toLowerCase(),
  );

  return {
    fileName: fileName,
    fileExtension: fileExtension,
    isImage: isImage,
    isDocument: isDocument,
    isPdf: isPdf,
    isPreviewUnsupported: isPreviewUnsupported,
  };
};
export const logEvent = (category, action, label, url) => {
  return ReactGA.event({
    category: category,
    action: action,
    label: label,
    location: url,
  });
};

export const validateFileSize = (file) => {
  if (!file || typeof file !== "object" || typeof file.size !== "number") {
    return {
      isValid: false,
      errorMessage:
        "Invalid file input. Expected a file object with a size property.",
    };
  }
  if (file.size > DOCUMENT_UPLOAD_MAX_SIZE) {
    return {
      isValid: false,
      errorMessage: `File size exceeds the ${Math.round(
        DOCUMENT_UPLOAD_MAX_SIZE / (1024 * 1024),
      )} MB limit.`,
    };
  }

  return { isValid: true, errorMessage: "" };
};

export function convertUTCToLocal(utcTime) {
  if (!utcTime) return "NA";
  let utcDate = new Date(utcTime);

  // Get the local time equivalent
  let localDate = new Date(utcDate.toLocaleString());

  // Extract the local hours, minutes, and seconds
  let localHours = localDate.getHours();
  let localMinutes = localDate.getMinutes();
  let localSeconds = localDate.getSeconds();

  // Determine AM/PM
  let ampm = localHours >= 12 ? "PM" : "AM";

  // Convert to 12-hour format
  localHours = localHours % 12;
  localHours = localHours ? localHours : 12; // Handle the case of 0 (midnight)

  // Ensure two-digit formatting for minutes and seconds
  localMinutes = localMinutes.toString().padStart(2, "0");
  localSeconds = localSeconds.toString().padStart(2, "0");

  return `${localHours}:${localMinutes} ${ampm}`;
}
export const handleMinsonChangeRainfall = (
  event,
  setFormValue,
  formValue,
  fieldName = "rainfall"
) => {
  const re = /^[0-9.]+$/;
  const inputValue = event?.target?.value;
  if (inputValue === "" || re.test(inputValue)) {
    let value = inputValue;
    let countdot = (value.match(/\./g) || []).length;

    if (countdot <= 1) {
      if (value === "") {
        setFormValue({ ...formValue, [fieldName]: "" });
      } else {
        if (value?.indexOf(".") === -1) {
          setFormValue({ ...formValue, [fieldName]: value });
        } else {
          const [integerPart, decimalPart] = value?.split(".");

          if (decimalPart.length <= 2) {
            setFormValue({ ...formValue, [fieldName]: value });
          } else {
            setFormValue({
              ...formValue,
              [fieldName]: `${integerPart}.${decimalPart?.substring(0, 2)}`,
            });
          }
        }
      }
    } else {
      setFormValue({ ...formValue, [fieldName]: "" });
    }
  }
};

export const getDateRange = (timeperiod) => {
  const currentDate = new Date();
  const calculatedEndDate = new Date(currentDate);
  calculatedEndDate.setDate(currentDate.getDate() - timeperiod);
  return {
    startDate: calculatedEndDate,
    endDate: currentDate,
  };
};

const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const getMonthNameFromDate = (dateString) => {
  if (dateString) {
    const date = new Date(dateString);
    return monthNames[date.getMonth()];
  } else {
    return "";
  }
};

export const getDivisionByServiceType = () => {
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  if (userInfo && userInfo?.divisions?.length > 0) {
    const serviceType = parseInt(SERVICE_TYPE());
    return userInfo.divisions.filter((x) => x?.serviceType === serviceType);
  } else if (userInfo && userInfo?.organisationList?.length > 0) {
    const serviceType = parseInt(SERVICE_TYPE());
    const divisions = userInfo.organisationList
      .flatMap((org) => org.divisions)
      .filter((x) => x?.serviceType === serviceType);
    return divisions;
  } else {
    return [];
  }
};

export const getAssetTypeValue = (key) => {
  const assetType = ASSET_TYPE?.find((item) => item.key === key);
  return assetType ? assetType.value : null;
};

export const getFilesForValue = (origin) => {
  switch (origin) {
    case "Inspections" || "Inspection":
      return 1;
    case "Observations":
      return 2;
    case "Incidents":
      return 3;
    default:
      return null;
  }
};

export const downloadExcel = (data, fileName = "data.xlsx") => {
  const fileExtension = fileName.split(".").pop().toLowerCase();
  if (fileExtension === "csv") {
    const csv = XLSX.utils.sheet_to_csv(XLSX.utils.json_to_sheet(data));
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    a.click();
    URL.revokeObjectURL(url);
  } else {
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(data);
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([wbout], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    a.click();
    URL.revokeObjectURL(url);
  }
};

export const downloadPDF = (data, columns, fileName = "data.pdf") => {
  const doc = new jsPDF();
  doc.autoTable(columns, data, { startY: 10 });
  doc.save(fileName);
};

export const calculatePercentageChange = (currentValue, previousValue) => {
  let change;
  if (previousValue === 0) {
    change = currentValue * 100;
  } else {
    change = ((currentValue - previousValue) / previousValue) * 100;
  }
  return `${change > 0 ? "+" : ""}${Math.round(change)}%`;
};

export const downloadFullPDF = async (
  pageId,
  filename,
  pages = ["pdf-content"],
) => {
  const loader = document.getElementById("pdf-loader");
  if (loader) {
    loader.style.display = "flex";
  }

  const hideInPdfSections = document.querySelectorAll(".hideinpdf");
  hideInPdfSections.forEach((section) => {
    section.style.display = "none";
  });

  const pageElement = document.getElementById(pageId);
  if (pageElement) {
    pageElement.classList.add("pdfStyles");
  }

  const getCanvasFromSection = async (sectionId) => {
    const section = document.getElementById(sectionId);
    if (!section) return null;
    return await html2canvas(section, { scale: 1.5 });
  };

  const pdf = new jsPDF("p", "mm", "a4");
  const sections = pages;
  const margin = 5;

  for (const sectionId of sections) {
    const canvas = await getCanvasFromSection(sectionId);
    if (!canvas) continue;

    const imgData = canvas.toDataURL("image/jpeg", 0.5);
    const imgWidth = 210 - 2 * margin;
    const pageHeight = 295;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;
    let heightLeft = imgHeight;

    let position = margin;
    pdf.addImage(imgData, "JPEG", margin, position, imgWidth, imgHeight);
    heightLeft -= pageHeight - 2 * margin;

    while (heightLeft > 0) {
      pdf.addPage();
      position = heightLeft - imgHeight + margin;
      pdf.addImage(imgData, "JPEG", margin, position, imgWidth, imgHeight);
      heightLeft -= pageHeight - 2 * margin;
    }

    if (sectionId !== sections[sections.length - 1]) {
      pdf.addPage();
    }
  }
  pdf.save(filename);

  if (pageElement) {
    pageElement.classList.remove("pdfStyles");
  }

  hideInPdfSections.forEach((section) => {
    section.style.display = "";
  });

  if (loader) {
    loader.style.display = "none";
  }
};
export const useInfiniteScroll = (
  fetchMoreData,
  dependencies = [],
  hasMore = true,
) => {
  const ref = useRef(null);
  const lastScrollTop = useRef(0);

  useEffect(() => {
    const handleScroll = () => {
      if (!hasMore) return;

      const el = ref.current;
      if (!el) return;

      const { scrollTop, scrollHeight, clientHeight } = el;

      if (scrollTop > lastScrollTop.current) {
        if (scrollTop + clientHeight >= scrollHeight - 5) {
          fetchMoreData();
        }
      }

      lastScrollTop.current = scrollTop;
    };

    const el = ref.current;
    if (el) {
      el.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (el) {
        el.removeEventListener("scroll", handleScroll);
      }
    };
  }, [hasMore, ...dependencies]);

  return ref;
};

export function getDayNameAndDate(dateString) {
  try {
    const date = new Date(dateString);

    if (isNaN(date)) {
      throw new Error("Invalid date");
    }

    const dayOptions = { weekday: "long" };
    const dateOptions = { year: "numeric", month: "2-digit", day: "2-digit" };
    const dayName = date.toLocaleDateString("en-US", dayOptions);

    const formattedDate = date
      ?.toLocaleDateString("en-US", dateOptions)
      ?.replace(/(\d+)\/(\d+)\/(\d+)/, "$1-$2-$3");

    return `${dayName}, ${formattedDate}`;
  } catch (error) {
    console.error("Error parsing date:", error);
    return "Invalid date";
  }
}

const blobToBase64 = (blob) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result); // This gives base64
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};

const compressImageCache = new Map();

const convertAndCompressImage = async (imageUrl) => {
  const response = await fetch(imageUrl);
  if (!response.ok) {
    throw new Error("Network response was not ok");
  }

  let blob = await response.blob();

  const isHeic =
    imageUrl?.toLowerCase()?.split("?")[0]?.endsWith(".heic") ||
    imageUrl?.toLowerCase()?.split("?")[0]?.endsWith(".heif") ||
    blob.type?.toLowerCase()?.includes("heic") ||
    blob.type?.toLowerCase()?.includes("heif");

  if (isHeic) {
    const { default: heic2any } = await import("heic2any");

    const convertedBlob = await heic2any({
      blob,
      toType: "image/jpeg",
      quality: 0.8,
    });
    blob = Array.isArray(convertedBlob) ? convertedBlob[0] : convertedBlob;
  }

  const imageFile = new File([blob], "image.jpg", {
    type: isHeic ? "image/jpeg" : blob.type,
  });

  const maxSizeKB = 100;
  const options = {
    maxSizeMB: maxSizeKB / 1024,
    maxWidthOrHeight: 1920,
    useWebWorker: true,
  };

  const compressedFile = await imageCompression(imageFile, options);
  return blobToBase64(compressedFile);
};

export const compressImage = async (imageUrl) => {
  if (!imageUrl) return null;

  if (compressImageCache.has(imageUrl)) {
    return compressImageCache.get(imageUrl);
  }

  const resultPromise = convertAndCompressImage(imageUrl).catch((error) => {
    console.error("Error compressing image:", error);
    compressImageCache.delete(imageUrl);
    return null;
  });

  compressImageCache.set(imageUrl, resultPromise);
  return resultPromise;
};

export const sortAlphabetically = (array) => {
  return (array ? [...array] : []).sort((a, b) =>
    (a?.value?.trim() ?? "").localeCompare(b?.value?.trim() ?? ""),
  );
};

export const getLabelByAssetType = (assetTypeValue) => {
  switch (assetTypeValue) {
    case 1:
      return "Project";
    case 2:
      return "Equipment";
    case 3:
      return "Vehicle";
    case 4:
      return "Custom asset";
    default:
      return "";
  }
};

export const getNoOptionsTextByAssetType = (assetTypeValue) => {
  switch (assetTypeValue) {
    case 1:
      return "No Project";
    case 2:
      return "No Equipment";
    case 3:
      return "No Vehicles";
    case 4:
      return "No Custom Assets";
    default:
      return "";
  }
};
export const getSlasFormatedDate = (dt) => {
  if (dt) {
    const [month, day, year] = dt?.split("-");
    if (!year || !month || !day) {
      throw new Error("Invalid date format. Expected format is MM-DD-YYYY.");
    }
    return `${year}/${month}/${day}`;
  }
  return "";
};
export const generateYears = (startYear, endYear) => {
  return Array.from({ length: endYear - startYear + 1 }, (_, index) => {
    const year = endYear - index;
    return { key: year, value: year.toString() };
  });
};

export const getItemType = (id) => {
  switch (id) {
    case 1:
      return GET_ITEM_LOG.Kudos;
    case 2:
      return GET_ITEM_LOG.Corrective;
    case 3:
      return GET_ITEM_LOG.Reprimand;
    case 4:
      return GET_ITEM_LOG.Action;
    default:
      return GET_ITEM_LOG.All;
  }
};

// for encoding special character in mail id
export const encodeSearchText = (searchText) => {
  return encodeURIComponent(searchText);
};

// check expiry date is greater than current date
export const isDateExpired = (date) => {
  if (date) {
    const [month, day, year] = date.split("-");
    const formattedDate = `${year}-${month}-${day}`;
    const currentDate = new Date();
    const expDate = new Date(formattedDate);
    if (isNaN(expDate)) {
      console.error("Invalid date:", formattedDate);
      return false;
    }
    const isExpired = expDate < currentDate;
    return isExpired;
  } else {
    return false;
  }
};

export const getEstablishmentTypeValue = (key, ESTABLISHMENT_TYPE) => {
  const entry = ESTABLISHMENT_TYPE?.find((item) => item?.key === key);
  return entry ? entry.value : null;
};

export const formatRainfall = (rainfall) => {
  const value = parseFloat(rainfall);
  if (isNaN(value)) {
    return null;
  }
  if (value === 0) {
    return 0;
  }
  if (value < 1) {
    return value < 0.01 ? 0 : (Math.round(value * 100) / 100).toFixed(2);
  }
  return (Math.round(value * 100) / 100).toFixed(2);
};

export const convertToISODate = (dateString) => {
  const [month, day, year] = dateString?.split("-");
  return `${year}-${month}-${day}`;
};

export const InactiveClient = () => {
  if (ORG_STATUS() === "0" && LOGIN_ORG_ID() !== ORG_ID()) {
    toast("This Client is Inactive");
    return true;
  }
  return false;
};

export const twoDigitAfterDecimal = (value) => {
  if (typeof value !== "number") return "";
  const truncatedValue = Math.floor(value * 100) / 100;
  return parseFloat(truncatedValue).toString();
};

export const parseDate = (dateString, format) => {
  if (!dateString) return null;

  if (dateString instanceof Date) {
    return dateString;
  }

  if (typeof dateString !== "string") {
    return null;
  }

  if (Date.parse(dateString)) {
    return new Date(dateString);
  }

  if (format === "MM-dd-yyyy") {
    const [month, day, year] = dateString?.split("-");
    return new Date(`${year}-${month}-${day}`);
  }

  if (format === "dd-MM-yyyy") {
    const [day, month, year] = dateString?.split("-");
    return new Date(`${year}-${month}-${day}`);
  }

  if (format === "yyyy-MM-dd") {
    return new Date(dateString);
  }

  return null;
};

export const formatToMMDDYYYY = (date) => {
  if (!date) return "";

  const d = new Date(date);

  if (isNaN(d)) return "";

  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  const yyyy = d.getFullYear();

  return `${mm}-${dd}-${yyyy}`;
};

// Replaces characters that are invalid in file names on Windows/macOS/Linux
// with a space (used to build safe downloaded-report file names), so words
// don't get jammed together (e.g. "Stolen/Lost Property" -> "Stolen Lost Property").
export const sanitizeFileName = (name) => {
  if (!name) return "";
  return name
    .replace(/[\\/:*?"<>|{}]/g, " ")
    .replace(/\s+/g, " ")
    .trim();
};

export const convertToLocalTime = (utcDate) => {
  let formattedUtcDate = utcDate?.slice(0, -3) + "Z";

  const date = new Date(formattedUtcDate);
  if (isNaN(date.getTime())) {
    console.error("Invalid date value");
    return;
  }

  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const options = {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
    timeZone: timeZone,
  };

  try {
    return new Intl.DateTimeFormat("en-US", options).format(date);
  } catch (error) {
    console.warn(`Error formatting date: ${error.message}`);
    return utcDate;
  }
};

export const getServiceTypeNames = (serviceTypes) => {
  const serviceTypeMap = {
    1: "Safety",
    2: "StormWater",
  };

  return serviceTypes
    .map((type) => serviceTypeMap[type])
    .filter(Boolean)
    .join(", ");
};

export const getUserInfo = () => {
  const stored = localStorage.getItem("userInfo");
  return stored ? JSON.parse(stored) : null;
};

export const getOriginalFileName = (url) => {
  if (!url || typeof url !== "string") return "";

  const filePart = url.split("/").pop();
  const match = filePart.match(/_unique_(.+)$/);

  if (match && match[1]) {
    return match[1];
  }

  return filePart;
};

export const getLabel = (list = [], key) => {
  const found = list?.find((item) => item.key === key);
  return found ? found.value : "N/A";
};

export const getDaysRemaining = (dateStr) => {
  if (!dateStr) return "-";

  const lastUpdated = new Date(dateStr);
  const expiryDate = new Date(lastUpdated);
  expiryDate.setDate(expiryDate.getDate() + 30);

  const now = new Date();
  const diffTime = expiryDate - now;

  const daysLeft = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  return daysLeft > 0 ? daysLeft : 0;
};

export const isTokenExpired = (token) => {
  try {
    if (!token) return true;

    const payload = JSON.parse(
      atob(token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/"))
    );
    const expiryTimeMs = payload.exp * 1000;
    const nowMs = Date.now();

    return expiryTimeMs < nowMs + 300000;
  } catch (error) {
    return true;
  }
};

export const refreshUserSession = async () => {
  const refreshToken = localStorage.getItem("refresh_token");
  const idToken = localStorage.getItem("id_token");

  if (!refreshToken || !idToken) {
    return null;
  }

  let username;
  try {
    const payload = JSON.parse(
      atob(idToken.split(".")[1].replace(/-/g, "+").replace(/_/g, "/"))
    );

    username =
      payload["cognito:username"] ||
      payload.sub ||
      payload.email ||
      payload.phone_number;
  } catch (error) {
    return null;
  }

  if (!username) {
    return null;
  }

  const cognitoUser = new CognitoUser({
    Username: username,
    Pool: UserPool,
  });

  const refreshTokenObj = new CognitoRefreshToken({
    RefreshToken: refreshToken,
  });

  return new Promise((resolve, reject) => {
    cognitoUser.refreshSession(refreshTokenObj, (err, session) => {
      if (err) {
        return reject(err);
      }

      cognitoUser.signInUserSession = session;

      const newIdToken = session.getIdToken().getJwtToken();
      const newAccessToken = session.getAccessToken().getJwtToken();

      resolve({
        idToken: newIdToken,
        accessToken: newAccessToken,
      });
    });
  });
};
//report analtics add % in value
export const formatPercentage = (value) => {
  if (value === null || value === undefined || value === "-") return "-";
  return `${Number(value)}%`;
};

export const getDateFromFormattedDate = (date) => {
  if (!date || typeof date !== "string") return "";
  const parts = date?.split("-");
  if (parts?.length !== 3) return "";
  return parts[1]?.padStart(2, "0");
};

// DivisionIds for Divistion Admin Roles
export function getUserBaseDivisionInfo() {
  const userInfo = JSON.parse(localStorage.getItem("userInfo")) || {};

  const hasBaseDivisionAdminAccess = userInfo?.privileges?.some(
    (i) => parseInt(i?.fixedRoleId) === 7,
  );

  const baseDivisionIds = hasBaseDivisionAdminAccess
    ? userInfo?.divisions
        ?.filter((d) => d?.serviceType === parseInt(PRODUCT_ID()))
        ?.map((d) => d?.key)
        ?.join(",")
    : null;

  return { hasBaseDivisionAdminAccess, baseDivisionIds };
}

export function roleAccess() {
  const HbnClientPartnerRole = hasAllPrivileges(SEFETY_HBN_CLIENT_PARTNER_PRI);
  const HbnClientSystemRole = hasAllPrivileges(SEFETY_HBN_CLIENT_SYSTEM_PRI);
  const HBNLimitedInspectorRole = hasAllPrivileges(HBN_LIMITED_INSPECTOR_ROLE);
  const OSHAManagementRole = hasAllPrivileges(OSHA_MANAGEMENT_ROLE);
  const SupervisorRole = hasAllPrivileges(SUPERVISOR_ROLE);
  return {
    HbnClientPartnerRole,
    HbnClientSystemRole,
    HBNLimitedInspectorRole,
    OSHAManagementRole,
    SupervisorRole,
  };
}

export const formatHourRange = (index) => {
  const startHour = index;
  const endHour = index + 1;

  const formatHour = (hour) => {
    if (hour === 0) return "12AM";
    if (hour === 12) return "12PM";
    if (hour === 24) return "12AM";
    if (hour < 12) return `${hour}AM`;
    return `${hour - 12}PM`;
  };

  return `${formatHour(startHour)}-${formatHour(endHour)}`;
};
export function isEmptyHtmlContent(html) {
  if (!html) return true;

  const cleaned = String(html)
    .replace(/<[^>]+>/g, "")
    .replace(/&nbsp;/gi, " ")
    .trim();

  return cleaned.length === 0;
}
export const convertUTCtoLocalTimeZoneNA = (
  utcDateString,
  dateOnly = false,
) => {
  // Handle empty or invalid values
  if (!utcDateString || utcDateString === "N/A") return "";

  const date = utcDateString.endsWith("Z")
    ? utcDateString
    : utcDateString + "Z";

  const utcDate = new Date(date);

  // Check if date is invalid
  if (isNaN(utcDate.getTime())) return "";

  const year = utcDate.getFullYear();
  const month = String(utcDate.getMonth() + 1).padStart(2, "0");
  const day = String(utcDate.getDate()).padStart(2, "0");

  if (dateOnly) {
    return `${month}-${day}-${year}`;
  }

  const hours = String(utcDate.getHours()).padStart(2, "0");
  const minutes = String(utcDate.getMinutes()).padStart(2, "0");

  return `${month}-${day}-${year} ${hours}:${minutes}`;
};

export const stripTimeToDate = (dateString) => {
  if (!dateString || dateString === "N/A") return "";
  const datePart = String(dateString).split(/[\sT]/)[0];
  const parts = datePart.split("-");
  if (parts.length !== 3) return "";
  const [yyyy, mm, dd] = parts;
  if (!yyyy || !mm || !dd) return "";
  return `${mm}-${dd}-${yyyy}`;
};

export const getYesNoValue = (key) => {
  const item = YES_NO.find((el) => el.key === key);
  return item ? item.value : "N/A";
};

export const formatRainfallValue = (value) => {
  if (value === null || value === undefined || isNaN(value)) {
    return "0.00";
  }

  return (Math.round((Number(value) + Number.EPSILON) * 100) / 100).toFixed(2);
};
